import * as React from 'react';
import { SVGProps } from 'react';

const IconHomeSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M13.274 2.387a.985.985 0 0 1 1.507.002l10.98 12.995c.55.65.092 1.653-.754 1.653H23V25a1 1 0 0 1-1 1h-5v-7h-6v7H6a1 1 0 0 1-1-1v-7.963H2.993c-.847 0-1.304-1.005-.752-1.655L13.275 2.387Z" />
  </svg>
);
export default IconHomeSizeL;
